import { request } from './client.js';

export type AdminUsageRange = 'day' | 'week';
export type AdminUsageStatus = 'queued' | 'running' | 'succeeded' | 'failed' | 'cancelled';

interface UsageCounters {
  readonly total: number;
  readonly regenerations: number;
  readonly adminReplays: number;
  readonly queued: number;
  readonly running: number;
  readonly succeeded: number;
  readonly failed: number;
  readonly cancelled: number;
}

export interface AdminUsageDto {
  readonly range: AdminUsageRange;
  readonly from: string;
  readonly to: string;
  readonly updatedAt: string;
  readonly live: { readonly queued: number; readonly running: number };
  readonly summary: UsageCounters & {
    readonly uniqueUsers: number;
    readonly uniqueBooks: number;
    readonly costUnits: string;
    readonly averageLatencyMs: number | null;
    readonly successRate: number;
  };
  readonly timeline: readonly {
    readonly start: string;
    readonly total: number;
    readonly regenerations: number;
    readonly succeeded: number;
    readonly failed: number;
    readonly costUnits: string;
  }[];
  readonly byTarget: readonly {
    readonly targetType: string;
    readonly total: number;
    readonly regenerations: number;
    readonly failed: number;
    readonly costUnits: string;
  }[];
  readonly topUsers: readonly {
    readonly id: string;
    readonly email: string;
    readonly name: string;
    readonly total: number;
    readonly regenerations: number;
    readonly failed: number;
    readonly costUnits: string;
  }[];
  readonly byStatus: readonly { readonly status: AdminUsageStatus; readonly count: number }[];
}

export const adminUsageApi = {
  summary: (range: AdminUsageRange) => request<AdminUsageDto>(`/admin/usage?range=${range}`),
};
